@import "~animatewithsass/animate.scss";

@mixin background {
  border-radius: 10px;
}

.cup-adjustment-row{
  .cup-adjustment{
    text-align: -webkit-center;
    @include background;
    .label{
      padding-bottom: 5px;
      font-size: 20px;
      font-weight:100;
    }
    hr {  }

    .inc-dec{
      border-radius: 10px;
      box-shadow: 0 5px 2px -1px black;
    }

    .size-adjustment{
      text-align: left;
    }
    .size-step{
      text-align: left;
      float: right;
      input{
        width: 127px;
        text-align: center;
      }
    }
    .max-min{
      text-align: -webkit-center;
      .minimum{
        text-align: left;
        display: table;
      }
      .maximum{
        text-align: left;
        display: table;
      }
    }

    .adjustment-true {
      height:auto;
      max-height: 600px !important;
      opacity:1;
      transition: max-height 2s ease,opacity 2s ease;
      overflow: hidden;
    }

    .adjustment-false{
      height:auto;
      max-height: 0 !important;
      opacity:0;
      transition: max-height 1s ease,opacity 2s ease;
      overflow: hidden;
    }
  }
}

@media (max-width: 767px) {

  .adjustment-true {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .adjustment-false{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .size-adjustment{
    // display: table;
  }
  .size-step{
    float: left !important;
    //display: table;
  }

  .max-min{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .remove-padding{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .max-min{
    text-align: -webkit-center;
    .minimum{
      text-align: left;
      float: left !important;
    }
    .maximum{
      text-align: left;
      float: left !important;
    }
  }

  .cup-adjustment{
    padding-left: 15px !important;
  }
}

@media (min-width: 1400px) {
  .cup-adjustment-row{
    .cup-adjustment{
      .label{
        font-size: 15px;
      }
    }
  }
}



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/drink-settings/cup-size-adjustment/cup-size-adjustment.scss